import { render, staticRenderFns } from "./person-details.vue?vue&type=template&id=3db14950"
import script from "./person-details.vue?vue&type=script&lang=js"
export * from "./person-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports